import { styled } from '@material-ui/core/styles';

export const SearchbarContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(4)
}));
